import { isUnsplashImage } from '../../../shared-components/UnsplashSearch/unsplashAPI';

type getImageTypeToShowProps = {
	imageSrc?: string;
};

export const getImageTypeToShow = ({ imageSrc }: getImageTypeToShowProps) => {
	const showUnsplashImage = isUnsplashImage(imageSrc);
	const showCustomUploadedImage = !!imageSrc && !isUnsplashImage(imageSrc);

	return {
		showUnsplashImage,
		showCustomUploadedImage,
		hasImage: showUnsplashImage || showCustomUploadedImage,
	};
};
